import { useEffect } from 'react';

const AngelAIWidget = ({ customLink, userType }) => {

  useEffect(() => {
    let normalizedLink = customLink;
    if (customLink && !customLink.endsWith('/')) {
      normalizedLink = customLink + '/';
    }

    const cleanup = () => {
      const existingScript = document.getElementById('angelai-widget');
      const existingLink = document.getElementById('angelai-widget-styles');
      const widgetContainer = document.querySelector('[id^="angelai"]');
      
      if (existingScript) existingScript.remove();
      if (existingLink) existingLink.remove();
      if (widgetContainer) widgetContainer.remove();
    };

    cleanup();

    const timer = setTimeout(() => {
      const link = document.createElement('link');
      link.id = 'angelai-widget-styles';
      link.rel = 'stylesheet';
      link.href = `${process.env.REACT_APP_ANGELAI_WIDGET_CSS}?v=${Date.now()}`;
      document.head.appendChild(link);
      
      const script = document.createElement('script');
      script.id = 'angelai-widget';
      script.src = `${process.env.REACT_APP_ANGELAI_WIDGET_JS}?v=${Date.now()}`;
      script.setAttribute('comicBubbleBackground', '#ffffffe6');
      script.setAttribute('comicBubbleBorderColor', '#FF6A1360');
      script.setAttribute('userType', userType || 'default');
      if (normalizedLink) {
        script.setAttribute('angelaiCustomLink', normalizedLink);
      }
      document.body.appendChild(script);
    }, 200);

    return () => {
      clearTimeout(timer);
    };
  }, [customLink, userType]);
  
  return null;
};

export default AngelAIWidget;